// 서버가 남긴 보호자 알림 실패 이유를 사장님·기사님 말로 바꾼다 — 관리자 카드와 기사 화면이 같은 말을 쓰게
export function plainNotifyReason(reason: string): string {
  if (!reason) return "이유를 알 수 없음";
  if (reason.includes("전화번호 없음")) return "보호자 번호가 없음";
  if (reason.includes("알림 받지 않음")) return "알림 받지 않음으로 설정된 집"; // 서버 completeHouseholdDelivery OPT_OUT_REASON
  if (reason.includes("키 미설정")) return "문자 설정 문제(콕소프트에 문의)";
  if (reason.includes("업체 번호")) return reason;
  if (reason.includes("발송 실패")) return "문자 발송 실패(번호가 틀렸거나 받을 수 없는 번호일 수 있음)";
  if (reason.includes("일부 실패") || reason.includes("건 실패")) return reason.replace(/\(.*?\)/g, "").trim();
  return reason.replace(/[A-Za-z_:]{12,}/g, "").trim() || "알 수 없는 오류";
}
